package org.gstechnovos.jexonplastech.sections.home.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val FeaturedCategoriesContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        // Alternating background color (Light Gray) to separate it from the previous white section
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.lightGray)
    }
}

val CategoryCardStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.white)
            .borderRadius(16.px)
            .padding(20.px)
            .boxShadow(0.px, 4.px, 15.px, color=palette.custom.darkText.toRgb().copyf(alpha = 0.05f))
            .transition(
                Transition.of("transform", 0.3.s),
                Transition.of("box-shadow", 0.3.s)
            )
    }
    hover {
        Modifier
            .translateY((-8).px)
            .boxShadow(0.px, 15.px, 30.px, color=palette.custom.darkText.toRgb().copyf(alpha = 0.12f))
    }
}

// Allows the text to change color when the parent card is hovered
val CategoryTitleStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .color(palette.custom.darkText)
            .transition(Transition.of("color", 0.2.s))
    }
    // Note: To make the title turn blue when the *card* is hovered,
    // we use a specific CSS rule targeted at the parent.
    // This will be applied via standard Compose modifiers in the component.
}